import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { GENERATED_QR_SLICE_NAME } from './models';
import { GeneratedQrAPI } from '@/api';
import { ICreateProductsQrDTO, IGeneratedQrListDTO, IGeneratedQrListResponse } from '@/models/generateQr.model';

export const getGeneratedQrList = createAsyncThunk<
  IGeneratedQrListResponse,
  IGeneratedQrListDTO,
  { serializedErrorType: IApiError }
>(
  `${GENERATED_QR_SLICE_NAME}/getGeneratedQrList`,
  async (data) => {
    const response = await GeneratedQrAPI.getGeneratedQrList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createProductsQrList = createAsyncThunk<
  undefined,
  ICreateProductsQrDTO,
  { serializedErrorType: IApiError }
>(
  `${GENERATED_QR_SLICE_NAME}/createProductsQrList`,
  async (data) => {
    const response = await GeneratedQrAPI.createProductsQrList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
